export class TrendDataModel {
  done: number;
  total: number;
  doneBefore: number;
  totalBefore: number;
  unit: string;
}
